import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import {
  STORE_CUSTOMERNAME, // use
  STORE_CUSTOMEREMAIL, // Use
  STORE_CUSTOMERADDRESSONE, // use
  STORE_CUSTOMERADDRESSTWO, // use
  STORE_CUSTOMERCOUNTRY, // use
  STORE_CUSTOMERSTATE, // use
  STORE_CUSTOMERCITY, // use
  STORE_CUSTOMERZIPCODE, // use
  STORE_CUSTOMERPOC, // use
  STORE_CUSTOMERPOCEMAIL, // use
  STORE_CUSTOMERPOCPHONENUMBER, // use
  STORE_CUSTOMERPRODUCTPORTFOLIO, // use
  STORE_CUSTOMERDESIGNSOFTWARE, // use
  STORE_CUSTOMERVERSIONOFSOFTWARE, // use
  STORE_CUSTOMERTURNAROUNDSERVICE, // use
  STORE_CUSTOMERPREFERENCEFORM, // use
  STORE_CUSTOMERMATERIALFILES, // use
  // Not used
  STORE_CUSTOMERTYPE,
  STORE_CUSTOMERFIRSTNAME,
  STORE_CUSTOMERLASTNAME,
  // STORE_CUSTOMERPHONENUMBER,
  STORE_CUSTOMERPRODUCT,
  STORE_CUSTOMERSCANNER,
  STORE_CUSTOMERCOMMAND,

} from '../reducers/signupUser';
import {
  STORE_ERROR_MESSAGE,
  STORE_ERROR_BAR,
  STORE_SUCCESS_MESSAGE,
  STORE_SUCCESS_BAR,
  STORE_SIGNUP_UPLOAD_ERROR,
  STORE_SIGNUP_UPLOAD_UPDATE
} from '../reducers/errors';
import axios, { AxiosResponse } from 'axios';
// import { push } from 'react-router-redux';

export const saveCustomerName = (customername: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    // const customername = custname.charAt(0).toUpperCase + custname.slice(1);
    dispatch({ type: STORE_CUSTOMERNAME, customername } as AnyAction);
    return true;
  };
};

export const saveEmail = (customeremail: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMEREMAIL, customeremail } as AnyAction);
    return true;
  };
};

export const saveAddressOne = (customeraddressone: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERADDRESSONE, customeraddressone } as AnyAction);
    return true;
  };
};

export const saveAddressTwo = (customeraddresstwo: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERADDRESSTWO, customeraddresstwo } as AnyAction);
    return true;
  };
};

export const saveCountry = (customercountry: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERCOUNTRY, customercountry } as AnyAction);
    return true;
  };
};

export const saveState = (customerstate: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERSTATE, customerstate } as AnyAction);
    return true;
  };
};

export const saveCity = (customercity: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERCITY, customercity } as AnyAction);
    return true;
  };
};

export const saveZipcode = (customerzipcode: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERZIPCODE, customerzipcode } as AnyAction);
    return true;
  };
};

export const savePoc = (customerpoc: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERPOC, customerpoc } as AnyAction);
    return true;
  };
};

export const savePocemail = (customerpocemail: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERPOCEMAIL, customerpocemail } as AnyAction);
    return true;
  };
};

export const savePocphonenumber = (customerpocphonenumber: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERPOCPHONENUMBER, customerpocphonenumber } as AnyAction);
    return true;
  };
};

export const saveProductportfolio = (customerproductportfolio: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERPRODUCTPORTFOLIO, customerproductportfolio } as AnyAction);
    return true;
  };
};

export const saveDesignsoftware = (customerdesignsoftware: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERDESIGNSOFTWARE, customerdesignsoftware } as AnyAction);
    return true;
  };
};

export const saveVersionofsoftware = (customerversionofsoftware: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERVERSIONOFSOFTWARE, customerversionofsoftware } as AnyAction);
    return true;
  };
};

export const savePreferenceform = (customerpreferenceform: File) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERPREFERENCEFORM, customerpreferenceform } as AnyAction);
    return true;
  };
};

export const saveTrunaroundservice = (customerturnaroundservice: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERTURNAROUNDSERVICE, customerturnaroundservice } as AnyAction);
    return true;
  };
};

export const saveMaterialfiles = (customermaterialfiles: File) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERMATERIALFILES, customermaterialfiles } as AnyAction);
    return true;
  };
};
// Not used State

// export const savePhonenumber = (customerphonenumber: string) => {
//   return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     // const customerphonenumber: number = Math.round(parseInt(pno, 10));
//     dispatch({ type: STORE_CUSTOMERPHONENUMBER, customerphonenumber } as AnyAction);
//     return true;
//   };
// };

export const saveProduct = (customerproduct: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERPRODUCT, customerproduct } as AnyAction);
    return true;
  };
};

export const saveScanner = (customerscanner: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERSCANNER, customerscanner } as AnyAction);
    return true;
  };
};

export const saveCommand = (customercommand: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERCOMMAND, customercommand } as AnyAction);
    return true;
  };
};

export const saveCustomerType = (customertype: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERTYPE, customertype } as AnyAction);
    return true;
  };
};

export const saveFirstname = (customerfirstname: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_CUSTOMERFIRSTNAME, customerfirstname } as AnyAction);
    return true;
  };
};

export const saveLastname = (customerlastname: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    // const customerlastname: number = Math.round(parseInt(pno, 10));
    dispatch({ type: STORE_CUSTOMERLASTNAME, customerlastname } as AnyAction);
    return true;
  };
};

export const doSignupUpload = async (
  dispatch: Dispatch<AppState>,
  getState: () => AppState
) => {
  console.log('TRUEE', getState().environment);
  const preferenceListParams = {
    custname: '',
    uploadedfile: '' as string | File,
  };
  preferenceListParams.custname = getState().signupUser.customername || '';
  preferenceListParams.uploadedfile = getState().signupUser.customerpreferenceform || '';

  if (preferenceListParams.uploadedfile === '') {
    const errorBar = true;
    const errorMessage = 'Please upload the preference form';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (preferenceListParams.custname === '') {
    const errorBar = true;
    const errorMessage = 'Customer Name should not be blank.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }
  const formdata1 = new FormData();
  for (const key in preferenceListParams) {
    if (preferenceListParams.hasOwnProperty(key)) {
      formdata1.append(key, preferenceListParams[key]);
    }
  }
  console.log('preferenceFormfile', preferenceListParams);
  if (getState().signupUser.customerpreferenceform) {
    await axios({
      method: 'post',
      url: `${getState().environment.SIGNUP_UPLOAD_URL}UploadSignupFiles`,
      data: formdata1,
    }).then(function (response: AxiosResponse) {
      console.error(response.data);
      const customerpreferenceform = '';
      dispatch({ type: STORE_CUSTOMERPREFERENCEFORM, customerpreferenceform } as AnyAction);
      // dispatch({ type: STORE_CUSTOMERPHONENUMBER, customerphonenumber } as AnyAction);
    }).catch(error => {

      const errorBar = true;
      // const errorMessage = error.response.data.error ? error.response.data.error.message : 'Error';
      const errorMessage = 'Error';
      dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
      dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);

    });
  }
  const materialFileParams = {
    custname: '',
    uploadedfile: '' as string | File,
  };
  materialFileParams.custname = getState().signupUser.customername || '';
  materialFileParams.uploadedfile = getState().signupUser.customermaterialfiles || '';
  const formdata2 = new FormData();
  for (const key in materialFileParams) {
    if (materialFileParams.hasOwnProperty(key)) {
      formdata2.append(key, materialFileParams[key]);
    }
  }
  console.log('materialFile', materialFileParams);
  if (getState().signupUser.customermaterialfiles) {

    await axios({
      method: 'post',
      url: `${getState().environment.SIGNUP_UPLOAD_URL}UploadSignupFiles`,
      data: formdata2,
    }).then(function (response: AxiosResponse) {
      console.log(response.data);
      const customermaterialfiles = '';
      dispatch({ type: STORE_CUSTOMERMATERIALFILES, customermaterialfiles } as AnyAction);

    }).catch(error => {

      const errorBar = true;
      // const errorMessage = error.response.data.error ? error.response.data.error.message : 'Error';
      const errorMessage = 'Error';
      dispatch({ type: STORE_SIGNUP_UPLOAD_ERROR, errorMessage } as AnyAction);
      dispatch({ type: STORE_SIGNUP_UPLOAD_UPDATE, errorBar } as AnyAction);

    });
  }
};

export const doSignup = async (
  dispatch: Dispatch<AppState>,
  getState: () => AppState
) => {

  const params = {
    transid: 'custm',
    recid: '0',
    custname: '',
    emailid: '',
    address1: '',
    address2: '',
    country: '',
    state: '',
    city: '',
    zip: '',
    poc: '',
    pocemail: '',
    pocphonenumber: '',
    products: '',
    designsoftware: '',
    software_version: '',
    turnaroundservice: '',
    preference_list: '' as string | File,
    dme_path: '' as string | File,
    // products: '',
    // scanners: '',
    // contactname: '',
    // contactno: '',
    // comments: '',
    // custtype: '',
    // phoneno: '',
  };

  console.log('params city', getState().signupUser.customercity);
  console.log('params state', getState().signupUser.customerstate);
  console.log('Files-param', getState().signupUser.customerpreferenceform);

  params.custname = getState().signupUser.customername || '';
  params.emailid = getState().signupUser.customeremail || '';
  params.address1 = getState().signupUser.customeraddressone || '';
  params.address2 = getState().signupUser.customeraddresstwo || '';
  params.country = getState().signupUser.customercountry || '';
  params.state = getState().signupUser.customerstate || '';
  params.city = getState().signupUser.customercity || '';
  params.zip = getState().signupUser.customerzipcode || '';
  params.poc = getState().signupUser.customerpoc || '';
  params.pocemail = getState().signupUser.customerpocemail || '';
  params.pocphonenumber = getState().signupUser.customerpocphonenumber || '';
  params.products = getState().signupUser.customerproductportfolio || '';
  params.designsoftware = getState().signupUser.customerdesignsoftware || '';
  params.software_version = getState().signupUser.customerversionofsoftware || '';
  params.turnaroundservice = getState().signupUser.customerturnaroundservice || '';
  params.preference_list = getState().signupUser.customerpreferenceform?.name || '';
  params.dme_path = getState().signupUser.customermaterialfiles?.name || '';
  // params.custtype = getState().signupUser.customertype || '';
  // params.contactname = getState().signupUser.customerfirstname || '';
  // params.contactno = getState().signupUser.customerlastname || '';

  // params.phoneno = getState().signupUser.customerphonenumber || '';

  // params.products = getState().signupUser.customerproduct || '';
  // params.scanners = getState().signupUser.customerscanner || '';
  // params.comments = getState().signupUser.customercommand || '';
  // params.city = getState().signupUser.customercity || '';
  // params.zipcode = getState().signupUser.customerzipcode || '';
  // console.log('Files-send', params.preference_list);

  if (params.custname === '') {
    const errorBar = true;
    const errorMessage = 'Please Enter the Name.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (params.emailid === '') {
    const errorBar = true;
    const errorMessage = 'Please Enter the Email ID.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(params.emailid)) {
      const errorBar = true;
      const errorMessage = 'Please enter a valid email address.';
      dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
      dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
      return;
    } else {
      const errorBar = false;
      dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    }
  }
  // if (params.emailid === '') {
  //   const errorBar = true;
  //   const errorMessage = 'Please Enter the Email ID.';
  //   dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
  //   dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  //   return;
  // } else {
  //   const errorBar = false;
  //   dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  // }

  if (params.address1 === '') {
    const errorBar = true;
    const errorMessage = 'Please Enter the Address 1.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (params.country === '') {
    const errorBar = true;
    const errorMessage = 'Please Select the Country.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (params.state === '') {
    const errorBar = true;
    const errorMessage = 'Please Select the State.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (params.city === '') {
    const errorBar = true;
    const errorMessage = 'Please Select the City.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (params.zip === '') {
    const errorBar = true;
    const errorMessage = 'Please Enter the Zip Code.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (params.poc === '') {
    const errorBar = true;
    const errorMessage = 'Please Enter the Point of Contact(POC).';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (params.pocemail === '') {
    const errorBar = true;
    const errorMessage = 'Please Enter the Email ID.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(params.pocemail)) {
      const errorBar = true;
      const errorMessage = 'Please enter a valid email address.';
      dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
      dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
      return;
    } else {
      const errorBar = false;
      dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    }
  }

  if (params.pocphonenumber === '') {
    const errorBar = true;
    const errorMessage = 'Please Enter the Contact No. (POC).';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (params.products === '') {
    const errorBar = true;
    const errorMessage = 'Please Select the Product Portfolio.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  // if (params.products === '') {
  //   const errorBar = true;
  //   const errorMessage = 'Choose the product';
  //   dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
  //   dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  //   return;
  // } else {
  //   const errorBar = false;
  //   dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  // }

  if (params.designsoftware === '') {
    const errorBar = true;
    const errorMessage = 'Please Select the Preferred design software.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (params.turnaroundservice === '') {
    const errorBar = true;
    const errorMessage = 'Please Select the Preferred Turnaround Service.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }

  if (params.software_version === '') {
    const errorBar = true;
    const errorMessage = 'Please Enter the Version of Software.';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
    return;
  } else {
    const errorBar = false;
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  }
  // if (params.contactname === '') {
  //   const errorBar = true;
  //   const errorMessage = 'Contact Name should not be blank.';
  //   dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
  //   dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  //   return;
  // } else {
  //   const errorBar = false;
  //   dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  // }

  // if (params.contactno === '') {
  //   const errorBar = true;
  //   const errorMessage = 'Contact Person Number should not be blank.';
  //   dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
  //   dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  //   return;
  // } else {
  //   const errorBar = false;
  //   dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  // }

  // if (params.phoneno === '') {
  //   const errorBar = true;
  //   const errorMessage = 'Phone number should not be blank.';
  //   dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
  //   dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  //   return;
  // } else {
  //   const errorBar = false;
  //   dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
  // }
  const formdata = new FormData();
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      formdata.append(key, params[key]);
    }
  }
  await axios({
    method: 'post',
    url: `${getState().environment.API_URL}signup`,
    data: formdata,
  }).then(function (response: AxiosResponse) {

    const userDetails = response.data;
    // // ==> console.error(userDetails);
    dispatch({ type: STORE_CUSTOMERNAME, userDetails } as AnyAction);

    const successBar = true;
    const successMessage = 'Successfully Saved. We will send Login Password to your Email ID';
    dispatch({ type: STORE_SUCCESS_MESSAGE, successMessage } as AnyAction);
    dispatch({ type: STORE_SUCCESS_BAR, successBar } as AnyAction);

    const customername = '';
    const customeremail = '';
    const customeraddressone = '';
    const customeraddresstwo = '';
    const customercountry = '';
    const customerstate = '';
    const customercity = '';
    const customerzipcode = '';
    const customerpoc = '';
    const customerpocemail = '';
    const customerpocphonenumber = '';
    const customerproductportfolio = '';
    const customerdesignsoftware = '';
    const customerversionofsoftware = '';
    const customerturnaroundservice = '';
    const customerpreferenceform = '';
    const customermaterialfiles = '';
    // Not used
    const customerproduct = '';
    const customerscanner = '';
    const customercommand = '';
    const customertype = '';
    const customerfirstname = '';
    const customerlastname = '';
    // const customerphonenumber = '';

    dispatch({ type: STORE_CUSTOMERNAME, customername } as AnyAction);
    dispatch({ type: STORE_CUSTOMEREMAIL, customeremail } as AnyAction);
    dispatch({ type: STORE_CUSTOMERADDRESSONE, customeraddressone } as AnyAction);
    dispatch({ type: STORE_CUSTOMERADDRESSTWO, customeraddresstwo } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCOUNTRY, customercountry } as AnyAction);
    dispatch({ type: STORE_CUSTOMERSTATE, customerstate } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCITY, customercity } as AnyAction);
    dispatch({ type: STORE_CUSTOMERZIPCODE, customerzipcode } as AnyAction);
    dispatch({ type: STORE_CUSTOMERPOC, customerpoc } as AnyAction);
    dispatch({ type: STORE_CUSTOMERPOCEMAIL, customerpocemail } as AnyAction);
    dispatch({ type: STORE_CUSTOMERPOCPHONENUMBER, customerpocphonenumber } as AnyAction);
    dispatch({ type: STORE_CUSTOMERPRODUCTPORTFOLIO, customerproductportfolio } as AnyAction);
    dispatch({ type: STORE_CUSTOMERDESIGNSOFTWARE, customerdesignsoftware } as AnyAction);
    dispatch({ type: STORE_CUSTOMERVERSIONOFSOFTWARE, customerversionofsoftware } as AnyAction);
    dispatch({ type: STORE_CUSTOMERTURNAROUNDSERVICE, customerturnaroundservice } as AnyAction);
    dispatch({ type: STORE_CUSTOMERPREFERENCEFORM, customerpreferenceform } as AnyAction);
    dispatch({ type: STORE_CUSTOMERMATERIALFILES, customermaterialfiles } as AnyAction);
    // Not used
    dispatch({ type: STORE_CUSTOMERTYPE, customertype } as AnyAction);
    dispatch({ type: STORE_CUSTOMERFIRSTNAME, customerfirstname } as AnyAction);
    dispatch({ type: STORE_CUSTOMERLASTNAME, customerlastname } as AnyAction);
    dispatch({ type: STORE_CUSTOMERPRODUCT, customerproduct } as AnyAction);
    dispatch({ type: STORE_CUSTOMERSCANNER, customerscanner } as AnyAction);
    dispatch({ type: STORE_CUSTOMERCOMMAND, customercommand } as AnyAction);
    // dispatch({ type: STORE_CUSTOMERPHONENUMBER, customerphonenumber } as AnyAction);

  }).catch(error => {
    // const customerdesignsoftware = '';
    // const customerturnaroundservice = '';

    // dispatch({ type: STORE_CUSTOMERDESIGNSOFTWARE, customerdesignsoftware } as AnyAction);
    // dispatch({ type: STORE_CUSTOMERTURNAROUNDSERVICE, customerturnaroundservice } as AnyAction);

    const errorBar = true;
    const errorMessage = error.response.data.msg || 'Error';
    dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
    dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);

  });
};

export const initiateLogin = async (
  dispatch: Dispatch<AppState>,
  getState: () => AppState
) => {
  const url = document.location!!.href;
  let loadUrl = url;
  var cnt = 0;
  var ind = 0;
  while (cnt !== 3) {
    ind = loadUrl.indexOf('/', ind) + 1;
    cnt++;
  }
  loadUrl = loadUrl.substring(0, ind);

  const callbackUrl = loadUrl;
  let responseType: string | undefined = getState().environment.ENV_MODE;
  responseType = responseType!!.split('-').join(' ');
  const loginUrl =
    `${getState().environment.ENV_MODE}` +
    `?client_id=${getState().environment.ENV_MODE}` +
    `&redirect_uri=${callbackUrl}callback` +
    `&response_type=${responseType}` +
    `&scope=app.esim_support`;

  window.location.replace(loginUrl || '');
};



// WEBPACK FOOTER //
// ./src/actions/signupAction.ts